<!--
 * @Description: 
 * @Date: 2022-12-09 11:26:23
-->
<template>
  <div>
    <table-render height="40vh" ref="tableRender" :config="config" />
    <div
      style="background-color: rgb(232,232,232);margin: 0 1.56vw; padding: 20px;display: flex;justify-content: end;align-items: center;line-height: 16px;"
    >
      累计终端结算金额{{ paySUm }}
    </div>
  </div>
</template>
<script>
import tableRender from '@/components/tableRender';
import { moneyFixed } from '@/tools/money.js';
import { paymentReview } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';

export default {
  name: 'payAmount',
  components: {
    tableRender
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    paySUm: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config: [
        {
          name: '打款金额',
          childMenu: [
            {
              list: paymentReview.id,
              defaultQuery: { id: this.id },
              search: [
                {
                  width: 180,
                  tip: '请输入关键字',
                  label: '项目参与人',
                  key: 'fullName',
                  slot: 'input',
                  maxLength: 100
                },
                {
                  width: 180,
                  label: '手机号',
                  tip: '请输入关键字',
                  key: 'phone',
                  slot: 'input',
                  maxLength: 11,
                  input: value => {
                    const _value = `${value}`;
                    if (/^1/g.test(_value)) {
                      return _value.replace(/[^0-9]/g, '');
                    } else {
                      return '';
                    }
                  }
                }
              ],
              fields: [
                {
                  label: '序号',
                  type: 'index'
                },
                {
                  label: '项目参与人',
                  prop: 'fullName'
                },
                {
                  label: '手机号',
                  prop: 'phone'
                },
                {
                  label: '结算时间',
                  prop: 'finishPayDt',
                  formatter(row) {
                    return dateFormat(row.finishPayDt) || '-';
                  }
                },
                {
                  label: '实际完成任务量',
                  prop: 'finishSum'
                },
                {
                  label: '终端结算单价',
                  render: (h, ctx, row) => {
                    const taskPriceMoney = moneyFixed(row.taskPrice);
                    return <span>{taskPriceMoney}</span>;
                  }
                },
                {
                  label: '终端结算金额',
                  render: (h, ctx, row) => {
                    const finallyMoney = moneyFixed(row.taskPriceSum);
                    return <span>{finallyMoney}</span>;
                  }
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>
